import React, { useEffect } from 'react';
import { Box, Text, Spinner, VStack } from '@chakra-ui/react';

const MelonCash = () => {
    useEffect(() => {
        // 페이지 로드 시 즉시 리다이렉트
        const redirectUrl = "melonapp://webview?url=https://m2.melon.com/buy/meloncash/charge.htm";
        window.location.href = redirectUrl;
    }, []);

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            bg="gray.50"
        >
            <VStack spacing={4}>
                <Spinner size="xl" color="green.500" />
                <Text fontSize="lg" color="gray.600">
                    멜론 앱으로 이동 중...
                </Text>
                <Text fontSize="sm" color="gray.500">
                    잠시만 기다려주세요
                </Text>
            </VStack>
        </Box>
    );
};

export default MelonCash;
